import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
@Injectable({ providedIn: 'root' })
export class MediaService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/Media`;
  }
  
  get(resourceName: string, expectedFormat: string, maxResolutionWith: number, maxResolutionHeight: number): Observable<Blob> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (resourceName !== undefined && resourceName !== null) {
      params = params.set('resourceName', resourceName.toString());
    }
    if (expectedFormat !== undefined && expectedFormat !== null) {
      params = params.set('expectedFormat', expectedFormat.toString());
    }
    if (maxResolutionWith !== undefined && maxResolutionWith !== null) {
      params = params.set('maxResolutionWith', maxResolutionWith.toString());
    }
    if (maxResolutionHeight !== undefined && maxResolutionHeight !== null) {
      params = params.set('maxResolutionHeight', maxResolutionHeight.toString());
    }
    
    return this.http.get(this.baseUrl, { 
      headers, 
      params, 
      responseType: 'blob'
    });
  }
  
  // Pomocnicza metoda do tworzenia URL do pliku
  getVideoUrl(resourceName: string, expectedFormat: string, maxResolutionWith: number, maxResolutionHeight: number): string {
    let params = new HttpParams();
    if (resourceName !== undefined && resourceName !== null) {
      params = params.set('resourceName', resourceName.toString());
    }
    if (expectedFormat !== undefined && expectedFormat !== null) {
      params = params.set('expectedFormat', expectedFormat.toString());
    }
    if (maxResolutionWith !== undefined && maxResolutionWith !== null) {
      params = params.set('maxResolutionWith', maxResolutionWith.toString());
    }
    if (maxResolutionHeight !== undefined && maxResolutionHeight !== null) {
      params = params.set('maxResolutionHeight', maxResolutionHeight.toString());
    }
    
    const token = localStorage.getItem('authToken');
    if (token) {
      params = params.set('Authorization', `Bearer ${token}`);
    }
    
    return `${this.baseUrl}?${params.toString()}`;
  }
  
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
